module.exports = __webpack_public_path__ + "img/1090167970.6cc30eee.jpg";